export default __webpack_public_path__ + "static/media/jose--mobile.ab77fa9e.jpg";